import React from 'react'
import { FinishPageConfig } from '../configuration'
import image from './assets/image.gif' 
import ImageTextBox from '../ImageTextBox'
import Container from '../Container'
import AssignId from '../AssignId'
import styles from './Finitura.module.sass'
import VisibilitySensor from '../VisibilitySensor'

export default function Finitura() {
  return (
    <div className={styles.root}>
      <Container>
        <AssignId
            absolute
            y='-120px'
            yMobile='-80px'
            id={FinishPageConfig.id}
        />
        <VisibilitySensor index={2} />
        <ImageTextBox
          intro={FinishPageConfig.intro}
          title={FinishPageConfig.title}
          description={FinishPageConfig.description}
          image={image} 
        />
      </Container>
    </div>
  )
}
